import actions from './actions';

export const genreTags = {
  namespaced: true,
  actions,
};
